import axios from 'axios';
import React from 'react';
import { CREATE_RATING, CREATE_TRACKING, CREATE_USER_PROFILE, GET_AUTH_INFO, GET_OLD_USER, LOGIN, SIGNUP } from './endpoints';

const getAuthenticatedHeaders = jwt => {
  return {
    headers: {
      Authorization: `Bearer ${jwt}`
    }
  };
};

export const createDepartmentRating = async (rating) => {
  if (
    !rating.clinic_id ||
    !rating.type ||
    !rating.entity_id ||
    rating.recommended === null ||
    !rating.perspective
  ) {
    console.log(rating);
    throw new Error('Bitte fülle mindestens den Klinik-Namen, die Abteilung, ob du die Abteilung empfehlen würdest und woher du die Klinik kennst aus.');
  }
  console.log('make one request..');
  const request = await axios.post(CREATE_RATING, rating);
  return request.data;
}
;

export const signup = async (signupData) => {
  console.log(signupData);
  if (!signupData.firstName) throw new Error('Bitte gib deinen Vornamen bei der Registrierung an.');
  if (!signupData.lastName) throw new Error('Bitte gib deinen Nachnamen bei der Registrierung an.');
  if (!signupData.email) throw new Error('Bitte gib deine E-Mail-Adresse bei der Registrierung an.');
  if (!signupData.password) throw new Error('Bitte gib dein Passwort bei der Registrierung an.');
  if (signupData.passwordRepeat !== signupData.password) throw new Error('Die von dir angegebenen Passwörter stimmen nicht überein.');
  console.log(SIGNUP);
  const request = await axios.post(SIGNUP, signupData);
  return request.data;
}
;

export const login = async (email, password) => {
  if (!email || !password) alert('Gib bitte die E-Mail-Adresse und das Passwort zum Einloggen ein.');

  const request = await axios.post(LOGIN, { email, password });
  return request.data;
}
;

export const createTracking = async (trackingData) => {
  const request = await axios.post(CREATE_TRACKING, trackingData);
  return request.data;
}
;

export const getAuthInfo = async (jwt) => {
  const request = await axios.get(GET_AUTH_INFO, getAuthenticatedHeaders(jwt));
  return request.data;
}
;

export const getOldUser = async (email) => {
  const request = await axios.get(GET_OLD_USER + '?email=' + email);
  return request.data;
}
;

export const createUserProfile = async (data, jwt) => {
  const request = await axios.post(CREATE_USER_PROFILE, data, getAuthenticatedHeaders(jwt));
  return request.data;
}
;
